import { TOUR_TRANSLATIONS } from "../translations"

export const getPricingChangesSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="pricing-changes-filters"]',
            title: t.pricingChangesFilters.title,
            content: t.pricingChangesFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="pricing-changes-widgets"]',
            title: t.pricingChangesWidgets.title,
            content: t.pricingChangesWidgets.content,
        },
        {
            target: '[data-tour="pricing-changes-table"]',
            title: t.pricingChangesTable.title,
            content: t.pricingChangesTable.content,
        },
        {
            target: '[data-tour="pricing-changes-create-report"]',
            title: t.pricingChangesCreateReport.title,
            content: t.pricingChangesCreateReport.content,
        },
        {
            target: '.MuiDialog-paper, .MuiDrawer-paper',
            title: t.pricingChangesEvolution.title,
            content: t.pricingChangesEvolution.content,
            placement: 'center',
            disableScrolling: true,
            data: { triggerClick: 'pricing-changes-table', closeOnLeave: true },
        },
    ]
}
